import React from 'react';
import { Building2 } from 'lucide-react';

// Professional context bar shown above the navbar on B2B routes. Unlike the
// competition ticker it is a persistent context indicator (not dismissable)
// so trade customers always know they are in the B2B area.
export default function B2BTicker() {
  return (
    <div className="fixed top-0 left-0 right-0 z-[55] h-8 bg-black border-b border-white/10 flex items-center">
      <div className="h-full flex items-center gap-2.5 px-4 lg:px-6 border-r border-white/10 bg-white/[0.03]">
        <Building2 className="w-3.5 h-3.5 text-primary" />
        <span className="text-primary text-[11px] font-bold tracking-[0.2em] leading-8">B2B</span>
      </div>
      <div className="flex-1 overflow-hidden whitespace-nowrap flex items-center">
        <div className="inline-flex animate-marquee">
          <span className="text-[11px] font-medium tracking-[0.18em] leading-8 text-white/70 px-6">
            TRADE PORTAL&nbsp;&nbsp;·&nbsp;&nbsp;PURCHASE ORDER UPLOAD&nbsp;&nbsp;·&nbsp;&nbsp;NET 30 TERMS AVAILABLE&nbsp;&nbsp;·&nbsp;&nbsp;STOCK ALLOCATION &amp; INVOICING&nbsp;&nbsp;·&nbsp;&nbsp;APPLY FOR A TRADE ACCOUNT&nbsp;&nbsp;·&nbsp;&nbsp;
          </span>
          <span className="text-[11px] font-medium tracking-[0.18em] leading-8 text-white/70 px-6" aria-hidden="true">
            TRADE PORTAL&nbsp;&nbsp;·&nbsp;&nbsp;PURCHASE ORDER UPLOAD&nbsp;&nbsp;·&nbsp;&nbsp;NET 30 TERMS AVAILABLE&nbsp;&nbsp;·&nbsp;&nbsp;STOCK ALLOCATION &amp; INVOICING&nbsp;&nbsp;·&nbsp;&nbsp;APPLY FOR A TRADE ACCOUNT&nbsp;&nbsp;·&nbsp;&nbsp;
          </span>
        </div>
      </div>
    </div>
  );
}